import Repository from '../../../../../foundation/repository/Repository';
import User from '../aggregates/user/User';
import ApiData from '../../../../../foundation/repository/ApiData';
import AuthenticationToken from '../aggregates/authenticationToken/AuthenticationToken';

export default class AuthenticationTokenRepository extends Repository<AuthenticationToken> {

	public mapObject (data: ApiData) {
		localStorage.setItem('authenticationToken', JSON.stringify(data.getData()));

		return this.mapAuthenticationToken(data.getData());
	}

	public getToken () {
		const data = localStorage.getItem('authenticationToken');

		if (data === null) {
			return undefined;
		}

		return this.mapAuthenticationToken(JSON.parse(data));
	}

	private mapAuthenticationToken (rawData: {}) {
		const data = new ApiData(rawData);

		return new AuthenticationToken(
			data.id<AuthenticationToken>('id'),
			data.timepoint('createdTimepoint'),
			data.id<User>('userId'),
			data.string('value'),
			data.timepoint('expiryTimepoint'),
			data.timepointOrNull('revokedTimepoint')
		);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/domain/repositories/AuthenticationTokenRepository.ts